import React from "react";

const TopBarOrders = () => (
    <svg className="custom-navbar__menu-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.4 6H15.1714M7.4 10.5H15.1714M7.4 15.5H10.8M10.8 21H7C5.34315 21 4 19.6569 4 18V5C4 3.34315 5.34315 2 7 2H15.5714C17.2283 2 18.5714 3.34315 18.5714 5V10.5M21 15L16.852 20.124C16.4748 20.5899 15.7752 20.6216 15.3575 20.1916L13.2286 18" stroke="black" strokeWidth="2" strokeLinecap="round"/>
    </svg>
)

export { TopBarOrders };